import React from 'react';
import _ from 'lodash';

import moment from 'moment';
import translator from 'translate-react';

import { connect } from 'react-redux';


/**
 * Render a string for the from - to period.
 *  @todo t10n, i18n
 */
export let textPeriod = function(from, to, nights, format) {
	if ( +from > +to  ) {
		let temp = to;
		to = from;
		from = temp;
	}

	let m_from = moment(from);
	let m_to = moment(to);
	let now = moment();

	if ( !from || !m_from.isValid() ) { return translator.get("Kein Zeitraum"); }
	if ( !to || !m_to.isValid() ) { return m_from.format("dd. DD.MM.YYYY") + " bis ..."; }

	let date_to = " " + translator.get("date_to") + " ";

	/* Standard */
	var result = m_from.format("DD.MM.YYYY") + date_to + m_to.format("DD.MM.YYYY");
	var weekdays = m_from.format("dd") + "-" + m_to.format("dd");

	/* Bei gleichem Jahr dieses ausblenden */
	if ( m_from.year() === m_to.year() && m_from.year() === now.year() ) {
		result = m_from.format("DD.MM.") + date_to + m_to.format("DD.MM.YYYY");
	}

	/* Gleicher Monat, aktuelles Jahr */
	if ( m_from.month() === m_to.month() && m_from.year() === now.year() ) {
		result = m_from.format("DD.") + date_to + m_to.format("DD. MMMM");
	}

	/* Gleicher Monat, anderes Jahr */
	if ( m_from.month() === m_to.month() && m_from.year() !== now.year() ) {
		result = m_from.format("DD. ") + date_to + m_to.format("DD. MMMM YYYY");
	}

	/* Nächte */
	if ( format === "long" ) {
		var nights_part;
		if ( nights === 1 ) {
			nights_part = translator.get("1 Nacht");
		} else {
			nights_part = nights + " " + translator.get("Nächte");
		}
		result = result + ", " + nights_part + " (" + weekdays + ")";
	}

	let guard = 10;
	while ( result.indexOf('  ') !== -1 ) {
		result = result.replace('  ', ' '); // Safari is the new IE
		guard--;
		if ( guard <= 0 ) break;
	}
	return result;
}



export function CalendarDisplay(props) {
	let { format } = props;
    let { selectionStart, selectionEnd, selectionEndHover, nights, selecting } = props.calendar;

    let text = "";

    let end = selectionEnd || selectionEndHover;

    if ( selectionStart && +selectionStart !== +end ) {
        text = textPeriod(selectionStart, end, nights, format);
    } else {
        text = "Bitte Zeitraum auswählen";
    	if ( +selectionStart === +end ) { text = "Abreisedatum wählen" };
    	if ( !selectionStart ) { text = "Anreisedatum wählen" };
    }

    return <span>{text}</span>;
}


const mapStateToProps = (state) => ({
	calendar: state.calendar,    
})

const mapDispatchToProps = (dispatch) => ({

})

export default connect(mapStateToProps, mapDispatchToProps)(CalendarDisplay);




/** WEBPACK FOOTER **
 ** ../ibe/components/CalendarDisplay.js
 **/